import { AttachmentFileType } from "@inrev/common";
import { FC } from "react";
import { UploadFile } from "../../types";
import { Icon } from "../primitives";
import { Spinner } from "../ui/Spinner";

type PendingUploadsProps = {
	pendingUploadFiles: readonly UploadFile<AttachmentFileType>[];
	completedUploadFiles: readonly UploadFile<AttachmentFileType>[];
};

const EMPTY_UPLOAD_FILES: readonly UploadFile<AttachmentFileType>[] = [];

export const PendingUploads: FC<PendingUploadsProps> = ({
	pendingUploadFiles = EMPTY_UPLOAD_FILES,
	completedUploadFiles = EMPTY_UPLOAD_FILES,
}) => {
	return (
		<>
			{(pendingUploadFiles.length > 0 || completedUploadFiles.length > 0) && (
				<div className="flex flex-col gap-1 px-2">
					{pendingUploadFiles.map((file) => (
						<div key={file.id} className="flex items-center gap-2 text-sm text-tertiary opacity-70">
							<Spinner
								containerClassName="h-4 w-4"
								spinnerClassName="h-4 w-4 border-2 border-solid border-sky-600 border-t-transparent"
							/>
							<span>
								{file.name}.{file.extension}
							</span>
							<span>Uploading…</span>
						</div>
					))}
					{completedUploadFiles.map((file) => (
						<div key={file.id} className="flex items-center gap-2 text-sm text-tertiary">
							<Icon type="check-circle" size="mini" color="confirm" />
							<span>
								{file.name}.{file.extension}
							</span>
							<span>Uploaded!</span>
						</div>
					))}
				</div>
			)}
		</>
	);
};
